function elementDisabled(element: HTMLElement, disabled: boolean): void {
    if (disabled) {
        element.setAttribute('disabled', '');
    } else {
        element.removeAttribute('disabled');
    }
}

// ----------------------------------------------------------------------------

export default elementDisabled;
